<template>
  <div class="about-page">
    <section class="about-hero">
      <div class="hero-copy"><span>{{ isEnglish ? 'ABOUT US' : '关于我们' }}</span><h1>{{ $t('about.text_0') }}</h1><p>{{ $t('about.text_1') }}</p></div>
      <div class="hero-image"><img src="/images/about.png" :alt="$t('about.text_0')"></div>
    </section>
    <section class="about-content">
      <div class="content-heading"><span>{{ isEnglish ? 'WHAT WE BELIEVE' : '我们的坚持' }}</span><h2>{{ isEnglish ? 'Technology, grounded in real value' : '以技术创造真实价值' }}</h2></div>
      <div class="value-grid">
        <article><b>01</b><h3>{{ $t('about.text_2') }}</h3></article>
        <article><b>02</b><h3>{{ $t('about.text_3') }}</h3></article>
        <article class="wide"><b>03</b><h3>{{ $t('about.text_4') }}</h3><ul><li>{{ $t('about.text_5') }}</li><li>{{ $t('about.text_6') }}</li><li>{{ $t('about.text_7') }}</li><li>{{ $t('about.text_8') }}</li></ul></article>
      </div>
      <div class="story"><p>{{ $t('about.text_9') }}</p><p>{{ $t('about.text_10') }}</p></div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'About',
  computed: { isEnglish() { return this.$i18n.locale.indexOf('en') !== -1; } },
  mounted() { document.body.className = 'site-page'; }
};
</script>
<style lang="stylus" scoped>
.about-page
  color #111c39
  background #f6f8fc
.about-hero
  max-width 1440px
  min-height 620px
  margin 0 auto
  padding 76px 48px 90px
  display grid
  grid-template-columns .8fr 1.2fr
  align-items center
  gap 70px
.hero-copy
  > span
    color #3566d4
    font-size 11px
    font-weight 750
    letter-spacing .18em
  h1
    margin 18px 0 24px
    font-size clamp(48px,6vw,78px)
    line-height 1.08
    letter-spacing -.055em
  p
    margin 0
    color #66738e
    font-size 17px
    line-height 1.9
    text-align justify
.hero-image
  border-radius 30px
  overflow hidden
  box-shadow 0 30px 70px rgba(28,46,94,.18)
  img
    display block
    width 100%
    aspect-ratio 1.55
    object-fit cover
.about-content
  max-width 1440px
  margin 0 auto
  padding 105px 48px 120px
  background #fff
.content-heading
  max-width 760px
  margin-bottom 44px
  span
    color #3566d4
    font-size 11px
    font-weight 750
    letter-spacing .18em
  h2
    margin 14px 0 0
    font-size clamp(36px,4vw,56px)
    letter-spacing -.045em
.value-grid
  display grid
  grid-template-columns repeat(2,minmax(0,1fr))
  gap 22px
  article
    padding 30px
    border 1px solid #e4e9f2
    border-radius 22px
    background #f8faff
  b
    display inline-flex
    align-items center
    justify-content center
    min-width 48px
    height 34px
    padding 0 12px
    color #4c70d4
    border-radius 999px
    background #e9efff
    font-size 18px
    line-height 1
    letter-spacing .04em
  h3
    margin 22px 0 0
    font-size 20px
    line-height 1.65
  .wide
    grid-column 1/-1
  ul
    display grid
    grid-template-columns repeat(2,minmax(0,1fr))
    gap 12px 32px
    margin 22px 0 0
    padding-left 20px
    color #65718b
    line-height 1.7
.story
  margin-top 28px
  padding 34px
  color #65718b
  border-left 3px solid #2e62d2
  background #f7f9fd
  p
    margin 0
    line-height 1.85
  p+p
    margin-top 15px
@media (max-width: 800px)
  .about-hero
    grid-template-columns 1fr
    padding 58px 24px 72px
  .about-content
    padding 76px 24px 84px
@media (max-width: 560px)
  .about-hero
    padding-left 20px
    padding-right 20px
  .about-content
    padding-left 20px
    padding-right 20px
  .value-grid
    grid-template-columns 1fr
  .wide
    grid-column auto !important
  .value-grid ul
    grid-template-columns 1fr
</style>
